import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import QuoteForm from "@/components/QuoteForm";
import { endpoints } from "@/lib/api";

export default function QuoteFormModal({ open, onOpenChange, defaultServiceSlug = "", productId = null, productName = "" }) {
  const [services, setServices] = useState([]);

  useEffect(() => {
    if (!open) return;
    endpoints.services().then(setServices).catch(() => {});
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="max-w-lg bg-white rounded-2xl border-0 shadow-2xl" data-testid="quote-modal">
        <DialogHeader className="text-start">
          <DialogTitle className="font-heading text-2xl font-bold text-[#0A1628]">
            {productName ? `عرض سعر: ${productName}` : "اطلب عرض سعر مجاني"}
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            املأ النموذج وسنعاود التواصل معك خلال 24 ساعة.
          </DialogDescription>
        </DialogHeader>
        <QuoteForm
          services={services}
          defaultServiceSlug={defaultServiceSlug}
          productId={productId}
          productName={productName}
          compact
          onSuccess={() => setTimeout(() => onOpenChange(false), 2500)}
          testIdPrefix="quote-form-modal"
        />
      </DialogContent>
    </Dialog>
  );
}
